import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import modal from './modal';

const SERVER_TIMEOUT_FOR_RECIPE_REQUEST_MILLS = 3000;

export default new Vuex.Store({
    strict: true,
    state: {
        modal,
        urls: Array,
        projectStates: Array,
        project: {},
        columns: Array
    },

    getters: {
        modal: state => {
            return state.modal;
        },
        urls: state => {
            return state.urls;
        },
        projectStates: state => {
            return state.projectStates;
        },
        project: state => {
            return state.project;
        },
        columns: state => {
            return state.columns;
        }
    },

    mutations: {
        openModal() {
            this.state.modal.open = true;
        },
        closeModal() {
            this.state.modal.link = {};
            this.state.modal.open = false;
        },
        setLoading(state, status) {
            this.state.modal.link = {};
            this.state.modal.loading = status;
        },
        setMessage(state, message) {
            this.state.modal.message = message;
        },
        setModalLink(state, link) {
            this.state.modal.link = link;
        },
        setModalAllowClose(state, status) {
            this.state.modal.allowClose = status;
        },
        setUrls(state, urls) {
            this.state.urls = urls;
        },
        setProjectStates(state, states) {
            this.state.projectStates = states;
        },
        setProject(state, project) {
            this.state.project = project;
        },
        setColumns(state, columns) {
            this.state.columns = columns;
        }
    },

    actions: {
        openModal: ({commit}) => {
            commit('openModal');
        },
        closeModal: ({commit}) => {
            commit('closeModal');
        },
        setLoading: ({commit}, status) => {
            commit('setLoading', status);
        },
        setMessage: ({commit}, message) => {
            commit('setMessage', message);
        },
        setModalLink: ({commit}, link) => {
            commit('setModalLink', link);
        },
        setModalAllowClose: ({commit}, status) => {
            commit('setModalAllowClose', status);
        },
        setUrls: ({commit}, urls) => {
            commit('setUrls', urls);
        },
        setProjectStates: ({commit}, states) => {
            commit('setProjectStates', states);
        },
        setProject: ({commit}, project) => {
            commit('setProject', project);
        },
        setColumns: ({commit}, columns) => {
            commit('setColumns', columns);
        },
        requestRecipeFromAPI: ({commit}, project) => {
            commit('setLoading', true);
            commit('openModal');
            commit('setModalAllowClose', false);
            commit('setMessage', 'Your recipe is being cooked!<br />Please wait, this process may take some minutes...');
            let url = process.env.MIX_API_URL + project.recipe.api_path + '/request?projectId=' + project.code;

            return new Promise(function callback(resolve, reject) {
                axios.get(url,
                    {headers: {'Bearer': process.env.MIX_API_AUTH_TOKEN}})
                    .then(function (response) {
                        // if the server tells us that we need to wait,
                        // we call again the same inner promise method, recursively
                        if (response.status === 202) {
                            console.log('recipe not ready yet...');
                            setTimeout(function () {
                                callback(resolve, reject);
                            }, SERVER_TIMEOUT_FOR_RECIPE_REQUEST_MILLS);
                        } else if (response.status !== 200) {
                            reject(response);
                        } else {
                            commit('setLoading', false);
                            commit('closeModal');
                            resolve(response);
                        }
                    }).catch(function (error) {
                        reject(error);
                    });

            });
        },
        handleError: ({commit}, error) => {
            console.error(error);
            commit('setLoading', false);
            commit('openModal');
            commit('setModalAllowClose', true);
            if (error.response && error.response.data) {
                console.log(error.response);
                commit('setMessage', error.response.data.message !== "" ? error.response.data.message : error.response.statusText);
            } else if (error)
                commit('setMessage', error);
            else
                commit('setMessage', 'We are experiencing some difficulties' +
                    ' handling your request right now.<br>Please try again later.');
        },
    }

});
